/**
 * @packageDocumentation
 * @module api.functional.auth.signup
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { AuthResponseDto } from "../../../structures/AuthResponseDto";
import type { SignUpDto } from "../../../structures/SignUpDto";

/**
 * @controller AuthController.signUp
 * @path POST /auth/signup
 * @accessor api.functional.auth.signup.signUp
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function signUp(
  connection: IConnection,
  body: signUp.Body,
): Promise<signUp.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...signUp.METADATA,
      template: signUp.METADATA.path,
      path: signUp.path(),
    },
    body,
  );
}
export namespace signUp {
  export type Body = SignUpDto;
  export type Output = AuthResponseDto;

  export const METADATA = {
    method: "POST",
    path: "/auth/signup",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/auth/signup";
}
